import React from 'react'
import Positions from '../../Viewer/ViewerContentArea/PositionsTrace/Positions'
import SubTitle from '../UI/SubTitles/SubTitle'
import styles from './ModalGPT.module.scss'
import posStyles from '../../Viewer/ViewerContentArea/PositionsTrace/Positions.module.scss'
import { PositionLabel } from '../../Viewer/path/PositionLabel'
import { CardTextBlock } from '../cards/CardTextBlock'
import { SuccessIcon, TriangleErrorIcon } from '../../helpers/icons'
import {getAllPlayers} from "../../Trainer/utils/helpers";
import {useSelector} from "react-redux";
import {selectLibraries} from "../../Redux/selectors/selectors";
import player from "../../Hands/HandFilter/filters/Player";

const SituationInfo = ({ trace, players, stacks, hands, spotId, isHero }) => {

	// select metadata
	const { librariesResponse } = useSelector(selectLibraries)
	const allPlayers = getAllPlayers(spotId, librariesResponse)

	const heroPosition = isHero.indexOf(true)

	const lastHeroAction = trace.find(t => {
		if (t['player'] === heroPosition){
			if (t['is_played'] && t['actions_played'][t['choose']] < 0.02){
				return true
			}
		}
	});

	console.log('stacks', stacks)

	return (
		<div className={styles.situationWrapper}>
			<div className={styles.players}>
				<div>
					<SubTitle text={'Hole cards'} level={6} />
					<div className={styles.playerCards}>
						<PositionLabel player={players[heroPosition]} />
						<CardTextBlock cards={hands[heroPosition]} isSquare isFullWidth />
					</div>
				</div>

				<div style={{display: 'flex', flexDirection: 'column'}}>
					<SubTitle text={'Player stacks'} level={6} />
					<div className={posStyles.positionsContainer}>

						{allPlayers.map((player, index) => (
							<div
								key={player.name}
								className={posStyles.positionCard}
								style={{
									opacity: player.is_fold ? 0.3 : 1,
									outline: heroPosition === index ? '1px solid var(--border_green)' : 'none',
								}}
							>
								<span>{player}</span>
								<span>{ stacks.length - 1 >= index ? stacks[index].toFixed(2) : ''}</span>
							</div>
						))}
					</div>
				</div>

			</div>

			<div>
				<SubTitle text={'Your last action'} level={6} />

				<div className={styles.lastActionWrapper}>
					{

						lastHeroAction.actions.map((item, index) => {
						const percent = lastHeroAction.actions_played[index]

						return (
							<div
								key={item}
								className={styles.lastAction}
								style={{
									borderBottom: index === lastHeroAction.choose ? '1px solid #FF897A' : '1px solid #64656a',
								}}
							>
								{percent >= 0.02 && <SuccessIcon />}
								{percent < 0.02 && <TriangleErrorIcon />}
								<span>{item.is_allin ? 'All in' : item}</span>
								<SubTitle text={`${(percent * 100).toFixed(0)}%`} level={6} style={{ marginBottom: 0 }} />
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}

export default SituationInfo
